// The part of a label that matched what was typed, so the eye lands on why
// each option is in the list.
export function HighlightedLabel({ label, query }: { label: string; query: string }) {
  const needle = query.trim().toLowerCase();
  const at = needle === '' ? -1 : label.toLowerCase().indexOf(needle);
  if (at < 0) return <span className="truncate">{label}</span>;

  return (
    <span className="truncate">
      {label.slice(0, at)}
      <mark className="bg-transparent font-semibold text-text-primary">
        {label.slice(at, at + needle.length)}
      </mark>
      {label.slice(at + needle.length)}
    </span>
  );
}
